import { observable, action } from "mobx";

class TourInboxImage {
  /**
   * @property {number|null}
   */
  @observable tourInboxImageId = null;

  /**
   * @property {number|null}
   */
  @observable tourId = null;

  /**
   * @property {string|null}
   */
  @observable imageClass = null;

  /**
   * @property {string|null}
   */
  @observable name = null;

  /**
   * @property {string|null}
   */
  @observable originalFileName = null;

  /**
   * @property {string|null}
   */
  @observable status = null;

  /**
   * @property {string|null}
   */
  @observable errorMessage = null;

  constructor(data) {
    if (typeof data !== "undefined") {
      this.setData(data);
    }
  }

  @action setData(data) {
    const {
      tourInboxImageId = null,
      tourId = null,
      imageClass = null,
      name = null,
      originalFileName = null,
      status = null,
      errorMessage = null,
    } = data;

    this.tourInboxImageId = tourInboxImageId;
    this.tourId = tourId;
    this.imageClass = imageClass;
    this.name = name;
    this.originalFileName = originalFileName;
    this.status = status;
    this.errorMessage = errorMessage;
  }
}

export default TourInboxImage;
